import { Tag } from 'antd';
import styled from 'styled-components';

import { PageWrapper } from '@style/pages/page.style';

import { Title } from '@atom/typography/typography';

export const SubTitleWrapper = styled.div`
  display: flex;
  padding: 0 0 16px;
  justify-content: center;
`;

export const SubTitle = styled(Title).attrs({
  level: 4,
  weight: 400,
})`
  flex: 1;
`;

export const RoleTag = styled(Tag).attrs({
  color: 'geekblue',
})`
  text-transform: capitalize;
`;

export const CredentialPageWrapper = styled(PageWrapper)`
  padding-right: 32px;
  min-width: 480px;
`;
